module.exports = __webpack_public_path__ + "static/hipsterSizes-ccbdee1e62c34066c2e3cf6bf1ac86e2.webp";